import React, {useEffect, useState} from 'react';
import PurchaseOrderList from '../../components/purchaseOrders/PurchaseOrderList';
import PurchaseOrderSearchForm from '../../components/purchaseOrders/PurchaseOrderSearchForm';
import {useLoader} from '@quadral/quadral-component-common/dist/components/loader/LoaderContext';
import QuadralContainer from '@quadral/quadral-component-common/dist/components/container';
import {purchaseOrdersService, realEstateService} from "../../services";

const PurchaseOrders = () => {
    const {showLoader, hideLoader} = useLoader();
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [totalRecords, setTotalRecords] = useState();
    const [searchFormData, setSearchFormData] = useState({
        orderNumber: '',
        street: '',
        billingZipCode: '',
        city: '',
        diagnostician: '',
        contact: '',
        status: [],
        managementUnitIds: [],
        customerReference: '',
        sort: {
            field: "effectiveDate",
            direction: "DESC"
        },
        pagination: {
            limit: 25,
            offset: 0
        }
    });
    const urlParams = new URLSearchParams(window.location.search);
    const statusParam = urlParams.get('statut');
    const [checkboxValue, setCheckboxValue] = useState(false);
    const [managementUnit, setManagementUnit] = useState();
    const [valueManagementUnit, setValueManagementUnit] = useState("");

    function getNextPage() {
        showLoader();
        let filteredCriterias = purchaseOrdersService.removeEmptyValue(searchFormData);
        filteredCriterias.pagination.offset = purchaseOrders.purchaseOrders.length;
        purchaseOrdersService.searchPurchaseOrders(filteredCriterias)
            .then(data => {
                setPurchaseOrders(po => ({
                    ...data,
                    purchaseOrders: [...po.purchaseOrders, ...data.purchaseOrders]
                }));
                hideLoader();
            })
            .catch(err => {
                console.error(err);
                hideLoader();
            });
    }

    function search(event) {
        if (event) event.preventDefault();
        showLoader();
        let filteredCriterias = purchaseOrdersService.removeEmptyValue(searchFormData);
        if (checkboxValue) {
            filteredCriterias = {
                ...filteredCriterias,
                onlyPurchaseOrderWithReportsToBeValidated: true,
            };
        }
        purchaseOrdersService.searchPurchaseOrders(filteredCriterias)
            .then(data => {
                setPurchaseOrders(data);
                setTotalRecords(data.totalRecords);
                hideLoader();
            })
            .catch(err => {
                console.error(err);
                hideLoader();
            });
        localStorage.setItem("savedUnit", searchFormData.managementUnitIds.join(','));
        const managementUnits = new CustomEvent('managementUnits', {
            detail: searchFormData.managementUnitIds
        });
        document.dispatchEvent(managementUnits);
    }

    function handleField(fieldName, value) {
        setSearchFormData(formData => ({
            ...formData,
            [fieldName]: value,
        }));
    }

    useEffect(() => {
        if (statusParam) handleField('status', [statusParam]);
    }, [statusParam]);

    useEffect(() => {
        if (searchFormData.status.length > 0 && searchFormData.status[0] === statusParam)
            search();
    }, [searchFormData.status, statusParam]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        realEstateService.getManagementUnitsByCompany()
            .then(data => setManagementUnit(data))
            .catch(err => console.error(err));
    }, []);

    useEffect(() => {
        const savedCompanies = localStorage.getItem("savedUnit");
        if (savedCompanies && savedCompanies !== "null" && savedCompanies !== "[]" && savedCompanies.trim() !== "") {
            setSearchFormData(prev => ({...prev, managementUnitIds: savedCompanies.split(',')}));
        }
        localStorage.setItem("savedUnit", savedCompanies);
    }, [managementUnit]);

    return (
        <>
            <QuadralContainer className="container-fluid container-view">
                <PurchaseOrderSearchForm
                    showLoader={showLoader}
                    hideLoader={hideLoader}
                    searchFormData={searchFormData}
                    setSearchFormData={setSearchFormData}
                    setPurchaseOrders={setPurchaseOrders}
                    checkboxValue={checkboxValue}
                    setCheckboxValue={setCheckboxValue}
                    handleField={handleField}
                    search={search}
                    valueManagementUnit={valueManagementUnit}
                    setValueManagementUnit={setValueManagementUnit}
                    managementUnit={managementUnit}
                />
            </QuadralContainer>
            <QuadralContainer className="container-fluid container-view bottom-padding scroll-x">
                <PurchaseOrderList
                    totalRecords={totalRecords}
                    purchaseOrders={purchaseOrders}
                    searchFormData={searchFormData}
                    setSearchFormData={setSearchFormData}
                    setTotalRecords={setTotalRecords}
                    setPurchaseOrders={setPurchaseOrders}
                    showLoader={showLoader}
                    hideLoader={hideLoader}
                    nextPageFn={getNextPage}
                    statusParam={statusParam}
                />
            </QuadralContainer>
        </>
    );
};

export default PurchaseOrders;